/* eslint react/prop-types: 0 */
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@lingui/macro';

import { COLUMN_TYPES } from '../data-table/DataTableColumns';
import { useQueryLoader } from '../data-table/Loaders';
import { FORMATTER_TYPES, DEFAULT_INVALID_VALUE } from '../../utilities/FormattingUtilities';
import { filterId as agentFilterId } from '../filters/agent-filter/AgentFilter';
import { filterId as testFilterId } from '../filters/test-filter/TestFilter';
import { MaterialUiIcon } from '../icon';
import ReportingDataTable from '../data-table/ReportingDataTable';
import { NATIVE_TEST, NATIVE_TEST_TYPE_GROUPS } from '../../utilities/TestTypeConstants';

const dataSource = {
    url: '/query/table',
    params: {
        type: 'test',
        entityFields: 'name,tags',
        metrics: ['status', 'availPercent'],
        trends: ['status'],
    },
};

const useStyles = makeStyles((theme) => ({
    tabTable: {
        paddingTop: theme.spacing(1),

        '@media print': {
            paddingTop: 0,
        },
    },
}));

function getInterface(row) {
    const testType = row?.test?.testType;
    const testTypeName = testType?.name;
    const testTypeGroup = testType?.group;

    // if this is a VoipPulseToPhone test, we do not show the interface type in Guardians. We will fix this in the first 3.6 patch.
    if (testTypeGroup === NATIVE_TEST_TYPE_GROUPS.VOIP && testTypeName === NATIVE_TEST.VoipPulseToPhone) {
        return DEFAULT_INVALID_VALUE;
    }
    return `${row?.test?.adapterType === 'wireless' ? 'Wireless' : 'Wired'}`;
}

const columns = [
    {
        type: COLUMN_TYPES.ICON,
        title: t`Type`,
        mapping: 'test.testType.details.icon',
        sortProperty: 'test.testType',
        sortable: true,
        width: 74,
        csvFormatter: (value, row) => row?.test?.typeNode?.details?.title,
        icons: [
            {
                getIcon: (row) => {
                    const { icon } = row?.test?.typeNode?.details || {};
                    return <MaterialUiIcon icon={icon} />;
                },
                getTooltip: (row) => row?.test?.typeNode?.details?.title,
            },
        ],
    },
    {
        type: COLUMN_TYPES.DRILLINLINK,
        title: t`Service Test`,
        sortable: true,
        mapping: 'test.name',
        width: 250,
        link: {
            target: '/test-detail',
            mappedFilterParams: {
                [testFilterId]: 'test',
            },
            excludedFilterParams: [agentFilterId],
        },
    },
    {
        title: t`Interface`,
        width: 80,
        mapper: (row) => getInterface(row),
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        title: t`Availability`,
        width: 115,
        sortable: true,
        mapping: 'availPercent',
        formatter: FORMATTER_TYPES.PERCENT,
    },
    {
        type: COLUMN_TYPES.STATUSTREND,
        title: t`Status Trend`,
        sortable: true,
        sortProperty: 'status',
        mapping: 'trends.status.data',
    },
    {
        type: COLUMN_TYPES.TESTLOGLINK,
        mapping: 'test',
        width: 110,
        uiOnly: true,
        link: {
            target: '/test-log',
            mappedFilterParams: {
                [testFilterId]: 'test',
            },
        },
    },
];

const sorters = [{ property: 'status', direction: 'desc' }];

export default function SiteTests(props) {
    const loader = useQueryLoader(dataSource);
    const classes = useStyles();

    return (
        <ReportingDataTable
            className={classes.tabTable}
            panelProps={props}
            loader={loader}
            columns={columns}
            sorters={sorters}
            deletedMapping="test.deleted"
        />
    );
}
